// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';
export const CLEAR_SHELTER_DATA = '[Portal] Clear Shelter Data';
export const LOAD_SHELTER_DATA = '[Portal] Load Shelter Data';
export const LOAD_SHELTER_DATA_SUCCESS = '[Portal] Load Shelter Data Success';
export const SAVE_SHELTER_DATA = '[Portal] Save Shelter Data';

export class SaveShelterData implements Action {
  readonly type = SAVE_SHELTER_DATA;
  constructor(public payload: any) {}
}

export class LoadShelterData implements Action {
  readonly type = LOAD_SHELTER_DATA;
  constructor(public payload: any) {}
}

export class LoadShelterDataSuccess implements Action {
  readonly type = LOAD_SHELTER_DATA_SUCCESS;
  constructor(public payload: any) {}
}

export class ClearShelterData implements Action {
  readonly type = CLEAR_SHELTER_DATA;
}

// action types
export type ShelterDataActions = ClearShelterData | LoadShelterData | LoadShelterDataSuccess | SaveShelterData;
